module.exports = __webpack_public_path__ + "img/GotoEatoki.ba230542.png";